// extracted by mini-css-extract-plugin
export default {"progressBar":"modern-progressbar_progressBar__CAi33","complete":"modern-progressbar_complete__ss80g"};